import React, { useEffect } from "react";
import AddApiKeyForm from "../../components/admin/api-key-geo";

const ApiPage = () => {

   useEffect(() => {
          document.body.id = "api-page-001";
        }, []);
  return (
    <div>
    <AddApiKeyForm />
    </div>
  );
};

export default ApiPage;
